import { Menu } from 'src/app/core/interfaces/ui/nav.interface';
import { PERMITTED_VIEWS } from '../global/global.constant';

export const MENU_ITEMS: Menu[] = [
  {
    id: PERMITTED_VIEWS.DASHBOARD,
    title: 'dashboard.titleSidebar',
    icon: 'home',
    type: 'link',
    badgeType: 'light-primary',
    path: '/dashboard',
    bookmark: true,
    children: [
      {
        id: PERMITTED_VIEWS.DASHBOARD_BETTING_OVERVIEW,
        title: 'dashboard.title.bettingOverview',
      },
      {
        id: PERMITTED_VIEWS.DASHBOARD_TOP_TABLES,
        title: 'dashboard.title.topTables',
        children: [
          {
            id: PERMITTED_VIEWS.DASHBOARD_TOP_TABLE_PLAYERS,
            title: 'dashboard.title.topPlayers',
          },
          {
            id: PERMITTED_VIEWS.DASHBOARD_TOP_TABLE_BONUSES,
            title: 'dashboard.title.topBonuses',
          },
          {
            id: PERMITTED_VIEWS.DASHBOARD_TOP_TABLE_AGENTS,
            title: 'dashboard.title.topAgents',
          },
        ],
      },

      {
        id: PERMITTED_VIEWS.DASHBOARD_GENERAL_STATISTICS,
        title: 'dashboard.title.generalStatistics',
        children: [
          {
            id: PERMITTED_VIEWS.DASHBOARD_STATISTICS_AGENTS_TODAY,
            title: 'dashboard.statistics.agentsToday',
          },
          {
            id: PERMITTED_VIEWS.DASHBOARD_STATISTICS_AGENTS_THIS_MONTH,
            title: 'dashboard.statistics.agentsThisMonth',
          },
          {
            id: PERMITTED_VIEWS.DASHBOARD_STATISTICS_AGENTS_TOTAL,
            title: 'dashboard.statistics.agentsTotal',
          },
          {
            id: PERMITTED_VIEWS.DASHBOARD_STATISTICS_PLAYERS_TODAY,
            title: 'dashboard.statistics.playersToday',
          },
          {
            id: PERMITTED_VIEWS.DASHBOARD_STATISTICS_PLAYERS_THIS_MONTH,
            title: 'dashboard.statistics.playersThisMonth',
          },
          {
            id: PERMITTED_VIEWS.DASHBOARD_STATISTICS_PLAYERS_TOTAL,
            title: 'dashboard.statistics.playersTotal',
          },
          {
            id: PERMITTED_VIEWS.DASHBOARD_STATISTICS_BETS_TODAY,
            title: 'dashboard.statistics.betsToday',
          },
          {
            id: PERMITTED_VIEWS.DASHBOARD_STATISTICS_BETS_THIS_MONTH,
            title: 'dashboard.statistics.betsThisMonth',
          },
          {
            id: PERMITTED_VIEWS.DASHBOARD_STATISTICS_ALL_CASH_DESK,
            title: 'dashboard.statistics.allCashDesk',
          },
          {
            id: PERMITTED_VIEWS.DASHBOARD_STATISTICS_MONTH_CASH_DESK,
            title: 'dashboard.statistics.monthCashDesk',
          },
          {
            id: PERMITTED_VIEWS.DASHBOARD_STATISTICS_TODAY_CASH_DESK,
            title: 'dashboard.statistics.todayCashDesk',
          },
        ],
      },
      {
        id: PERMITTED_VIEWS.DASHBOARD_TOTAL_TYPE_BETS,
        title: 'dashboard.title.totalTypesBets',
      },
    ],
  },
  {
    id: PERMITTED_VIEWS.PLAYERS,
    title: 'players.titleSidebar',
    icon: 'user',
    type: 'sub',
    badgeType: 'light-primary',
    children: [
      {
        id: PERMITTED_VIEWS.PLAYER_LIST,
        path: '/players/players-list',
        title: 'players.titleSidebar',
        type: 'link',
        children: [
          {
            id: PERMITTED_VIEWS.PLAYER_ADD_BTN,
            title: 'profile.utilsNav.addPlayerView',
          },
          {
            id: PERMITTED_VIEWS.PLAYER_UNLOCK_BTN,
            title: 'players.player.viewUnlockPlayer',
          },
          {
            id: PERMITTED_VIEWS.PLAYER_MESSAGE_SEND_BTN,
            title: 'players.player.viewMessagesPlayer',
          },
          {
            id: PERMITTED_VIEWS.PLAYER_EDIT_BTN,
            title: 'players.player.viewEditPersonalInfoBtnPlayer',
          },
          {
            id: PERMITTED_VIEWS.PLAYER_VERIFY_CHECK,
            title: 'players.player.viewVerifyPlayer',
          },
          {
            id: PERMITTED_VIEWS.PLAYER_CELLPHONE_VERIFY_CHECK,
            title: 'players.player.viewCellPhoneVerifyPlayer',
          },
          {
            id: PERMITTED_VIEWS.PLAYER_EMAIL_VERIFY_CHECK,
            title: 'players.player.viewEmailVerifyPlayer',
          },
          {
            id: PERMITTED_VIEWS.PLAYER_2FA_CHECK,
            title: 'players.player.viewTwoAFPlayer',
          },
          {
            id: PERMITTED_VIEWS.PLAYER_PASSWORD_CHANGE_CHECK,
            title: 'players.player.viewPasswordChangePlayer',
          },
          {
            id: PERMITTED_VIEWS.PLAYER_PRIVATE_INFO_NAV,
            title: 'players.player.viewPrivatePlayerInfo',
          },
          {
            id: PERMITTED_VIEWS.PLAYER_RESTRICTIONS_NAV,
            title: 'players.player.viewRestrictionPlayer',
          },
          {
            id: PERMITTED_VIEWS.PLAYER_DOCUMENT_IMAGE_NAV,
            title: 'players.player.viewDocumentImagePlayer',
          },
          {
            id: PERMITTED_VIEWS.PLAYER_NOTE_NAV,
            title: 'players.notes.label',
          },
          {
            id: PERMITTED_VIEWS.PLAYER_MESSAGE_NAV,
            title: 'players.messages.message',
          },
          {
            id: PERMITTED_VIEWS.PLAYER_BONUSES_NAV,
            title: 'players.player.viewBonusesPlayer',
          },
          {
            id: PERMITTED_VIEWS.SET_DEPOSIT_ROLLOVER,
            title: 'players.player.setDepositRollOver',
          },
          {
            id: PERMITTED_VIEWS.PLAYER_TRANSACTIONS_NAV,
            title: 'players.player.viewTransactionsPlayer',
          },
          {
            id: PERMITTED_VIEWS.MESSAGE_PLAYERS_WITH_AGENT,
            title: 'players.player.viewMessagePlayersWithAgent',
          },
          {
            id: PERMITTED_VIEWS.BTN_ADD_TRANSFER_CORRECTION,
            title: 'players.player.viewAddTransferCorrection',
          },
        ],
      },
      {
        id: PERMITTED_VIEWS.PLAYERS_BLOCKED,
        path: '/players/players-blocked',
        title: 'players.blocked.title',
        type: 'link',
        children: [
          {
            id: PERMITTED_VIEWS.UNBLOCK_BTN_BLOCKED_PLAYER,
            title: 'players.blocked.viewUnblockBtn',
          },
        ],
      },
      {
        id: PERMITTED_VIEWS.PLAYERS_TRANSFER,
        path: '/players/players-transfer',
        title: 'players.transferred.title',
        type: 'link',
      },
      {
        id: PERMITTED_VIEWS.PLAYERS_ACTIVE,
        path: '/players/active-players-list',
        title: 'players.activePlayer.title',
        type: 'link',
        children: [
          {
            id: PERMITTED_VIEWS.SETTING_BTN_ACTIVE_PLAYER,
            title: 'players.activePlayer.viewSettingBtn',
          },
          {
            id: PERMITTED_VIEWS.CHANGE_PASSWORD_ACTIVE_PLAYER,
            title: 'players.activePlayer.changePassword',
          },
          {
            id: PERMITTED_VIEWS.MOVE_ACTIVE_PLAYER,
            title: 'players.activePlayer.movePlayer',
          },
          {
            id: PERMITTED_VIEWS.BLOCK_ACTIVE_PLAYER,
            title: 'players.activePlayer.blockPlayer',
          },
          {
            id: PERMITTED_VIEWS.WRITE_NOTES_ACTIVE_PLAYER,
            title: 'players.activePlayer.notes',
          },
        ],
      },
      {
        id: PERMITTED_VIEWS.VERIFICATION_REQUEST,
        path: '/players/verification-request',
        title: 'players.verificationRequest.title',
        type: 'link',
      },
    ],
  },
  {
    id: PERMITTED_VIEWS.REPORTS,
    title: 'reports.title',
    icon: 'charts',
    type: 'sub',
    badgeType: 'light-primary',
    children: [
      {
        id: PERMITTED_VIEWS.GENERAL_REPORTS,
        title: 'reports.generalReports.title',
        type: 'sub',
        children: [
          {
            id: PERMITTED_VIEWS.GENERAL_PRODUCTS_REPORTS,
            path: '/reports/general-products',
            title: 'reports.generalReports.generalProductsReports.title',
            type: 'link',
            children: [
              {
                id: PERMITTED_VIEWS.GENERAL_REPORTS_EXPORT_PRODUCT_BTN,
                title: 'reports.generalReports.exportData',
              },
            ],
          },
          {
            id: PERMITTED_VIEWS.GENERAL_USERS_REPORTS,
            path: '/reports/general-users',
            title: 'reports.generalReports.generalUsersReports.title',
            type: 'link',
            children: [
              {
                id: PERMITTED_VIEWS.GENERAL_REPORTS_EXPORT_USER_BTN,
                title: 'reports.generalReports.exportData',
              },
            ],
          },
          {
            id: PERMITTED_VIEWS.GENERAL_PLAYERS_REPORTS,
            path: '/reports/general-players',
            title: 'reports.generalReports.generalPlayersReports.title',
            type: 'link',
            children: [
              {
                id: PERMITTED_VIEWS.GENERAL_REPORTS_EXPORT_PLAYER_BTN,
                title: 'reports.generalReports.exportData',
              },
            ],
          },
          {
            id: PERMITTED_VIEWS.GENERAL_AGENTS_DATAMART_REPORTS,
            path: '/reports/general-agents-datamart',
            title: 'reports.generalReports.generalAgentsDatamartReports.title',
            type: 'link',
            children: [
              {
                id: PERMITTED_VIEWS.GENERAL_REPORTS_EXPORT_AGENT_DATAMART_BTN,
                title: 'reports.generalReports.exportData',
              },
            ],
          },
          {
            id: PERMITTED_VIEWS.GENERAL_PLAYERS_DATAMART_REPORTS,
            path: '/reports/general-players-datamart',
            title: 'reports.generalReports.generalPlayersDatamartReports.title',
            type: 'link',
            children: [
              {
                id: PERMITTED_VIEWS.GENERAL_REPORTS_EXPORT_PLAYER_DATAMART_BTN,
                title: 'reports.generalReports.exportData',
              },
            ],
          },
        ],
      },
      {
        id: PERMITTED_VIEWS.REPORTS_SPORTS_BETTING,
        title: 'reports.sportsBetting.title',
        type: 'sub',
        children: [
          {
            id: PERMITTED_VIEWS.REPORTS_SPORTS_BETTING_BETTING,
            path: '/reports/betting',
            title: 'reports.sportsBetting.bettingReport',
            type: 'link',
            children: [
              {
                id: PERMITTED_VIEWS.REPORTS_SPORTS_BETTING_EXPORT_BET_BTN,
                title: 'reports.generalReports.exportData',
              },
              {
                id: PERMITTED_VIEWS.CANCEL_BET_BUTTON,
                title: 'reports.sportsBetting.viewCancelBet',
              },
              {
                id: PERMITTED_VIEWS.REPORTS_SPORTS_BETTING_DOWNLOAD_TICKET_BTN,
                title: 'reports.sportsBetting.viewTicketDownload',
              },
            ],
          },
          {
            id: PERMITTED_VIEWS.REPORTS_SPORTS_BETTING_SPORTS,
            path: '/reports/sports',
            title: 'reports.sportsBetting.sportsReport',
            type: 'link',
          },
          {
            id: PERMITTED_VIEWS.REPORTS_SPORTS_BETTING_CATEGORIES,
            path: '/reports/sports/categories',
            title: 'reports.sportsBetting.categoriesReport',
            type: 'link',
          },
          {
            id: PERMITTED_VIEWS.REPORTS_SPORTS_BETTING_EVENTS,
            path: '/reports/sports/categories/tournaments/events',
            title: 'reports.sportsBetting.eventsReport',
            type: 'link',
          },
          {
            id: PERMITTED_VIEWS.REPORTS_SPORTS_BETTING_MARKETS,
            path: '/reports/sports/categories/tournaments/events/markets',
            title: 'reports.sportsBetting.marketsReport',
            type: 'link',
          },
        ],
      },
      {
        id: PERMITTED_VIEWS.REPORTS_CASINO,
        title: 'reports.casino.title',
        type: 'sub',
        children: [
          {
            id: PERMITTED_VIEWS.REPORTS_CASINO_BY_BETS,
            path: '/reports/report-by-bet',
            title: 'reports.casino.reportBets',
            type: 'link',
            children: [
              {
                id: PERMITTED_VIEWS.REPORTS_CASINO_BET_EXPORT_BTN,
                title: 'reports.generalReports.exportData',
              },
            ],
          },
          {
            id: PERMITTED_VIEWS.REPORTS_CASINO_BY_GAMES,
            path: '/reports/report-by-games',
            title: 'reports.casino.reportGames',
            type: 'link',
          },
          {
            id: PERMITTED_VIEWS.REPORTS_CASINO_BY_PARTNER,
            path: '/reports/report-by-partner',
            title: 'reports.casino.reportPartner',
            type: 'link',
          },
          {
            id: PERMITTED_VIEWS.REPORTS_CASINO_BY_PLAYER,
            path: '/reports/report-by-players',
            title: 'reports.casino.reportPlayer',
            type: 'link',
          },
          {
            id: PERMITTED_VIEWS.REPORTS_CASINO_BY_PROVIDER,
            path: '/reports/report-by-provider',
            title: 'reports.casino.reportProvider',
            type: 'link',
          },
        ],
      },
      {
        id: PERMITTED_VIEWS.REPORTS_LIVE_CASINO,
        title: 'reports.liveCasino.title',
        type: 'sub',
        children: [
          {
            id: PERMITTED_VIEWS.REPORTS_LIVE_CASINO_BY_BETS,
            path: '/reports/report-live-casino-by-bet',
            title: 'reports.casino.reportBets',
            type: 'link',
          },
          {
            id: PERMITTED_VIEWS.REPORTS_LIVE_CASINO_BY_GAMES,
            path: '/reports/report-live-casino-by-games',
            title: 'reports.casino.reportGames',
            type: 'link',
          },
          {
            id: PERMITTED_VIEWS.REPORTS_LIVE_CASINO_BY_CURRENCY,
            path: '/reports/report-live-casino-by-currency',
            title: 'reports.casino.reportPartner',
            type: 'link',
          },
          {
            id: PERMITTED_VIEWS.REPORTS_LIVE_CASINO_BY_PLAYER,
            path: '/reports/report-live-casino-by-players',
            title: 'reports.casino.reportPlayer',
            type: 'link',
          },
          {
            id: PERMITTED_VIEWS.REPORTS_LIVE_CASINO_BY_PROVIDER,
            path: '/reports/report-live-casino-by-providers',
            title: 'reports.casino.reportProvider',
            type: 'link',
          },
        ],
      },
      {
        id: PERMITTED_VIEWS.SPECIAL_BETS,
        title: 'reports.specialBets.title',
        type: 'sub',
        children: [
          {
            id: PERMITTED_VIEWS.REPORTS_SPECIAL_BETS,
            path: '/reports/report-special-bets',
            title: 'reports.specialBets.reportSpecialBets.title',
            type: 'link',
            children: [
              {
                id: PERMITTED_VIEWS.REPORTS_SPECIAL_BETS_EXPORT_DATA,
                title: 'reports.generalReports.exportData',
              },
            ],
          },
        ],
      },
      {
        id: PERMITTED_VIEWS.VIRTUAL_BETS,
        title: 'reports.virtualBets.title',
        type: 'sub',
        children: [
          {
            id: PERMITTED_VIEWS.REPORTS_VIRTUAL_BETS,
            path: '/reports/report-virtual-bets',
            title: 'reports.specialBets.reportSpecialBets.title',
            type: 'link',
          },
        ],
      },
      {
        id: PERMITTED_VIEWS.REPORTS_LOADS_AND_WITHDRAWALS,
        title: 'reports.loadsAndWithdrawals.title',
        type: 'sub',
        children: [
          {
            id: PERMITTED_VIEWS.REPORTS_AGENTS_LIST_LOADS_AND_WITHDRAWALS,
            path: '/reports/agents',
            title: 'reports.loadsAndWithdrawals.agents',
            type: 'link',
            children: [
              {
                id: PERMITTED_VIEWS.REPORT_LOADS_WITHDRAWALS_AGENT_EXPORT_BTN,
                title: 'reports.generalReports.exportData',
              },
            ],
          },
          {
            id: PERMITTED_VIEWS.REPORTS_COLLABORATORS_LIST_LOADS_AND_WITHDRAWALS,
            path: '/reports/collaborators',
            title: 'reports.loadsAndWithdrawals.colaborators',
            type: 'link',
          },
          {
            id: PERMITTED_VIEWS.REPORTS_PLAYERS_LIST_LOADS_AND_WITHDRAWALS,
            path: '/reports/players',
            title: 'reports.loadsAndWithdrawals.players',
            type: 'link',
          },
        ],
      },
      {
        id: PERMITTED_VIEWS.REPORTS_TRANSACTION_REPORTS,
        title: 'reports.transactionReports.title',
        type: 'sub',
        children: [
          {
            id: PERMITTED_VIEWS.EXPORT_EXCEL_SORTI,
            title: 'words.exportExcelSorti',
          },
          {
            id: PERMITTED_VIEWS.EXPORT_EXCEL_TRANSACTION_REPORTS,
            title: 'words.exportDataTooltip',
          },
          {
            id: PERMITTED_VIEWS.REPORTS_TRANSACTION_REPORTS_ALL_TRANSACTIONS,
            path: '/reports/all-transactions',
            title: 'financial.transactions.title',
            type: 'link',
          },
          {
            id: PERMITTED_VIEWS.REPORTS_TRANSACTION_REPORTS_AGENTS,
            path: '/reports/agents-transactions',
            title: 'reports.loadsAndWithdrawals.agents',
            type: 'link',
          },
          {
            id: PERMITTED_VIEWS.REPORTS_TRANSACTION_REPORTS_PLAYERS,
            path: '/reports/players-transactions',
            title: 'reports.loadsAndWithdrawals.players',
            type: 'link',
          },
        ],
      },
      {
        id: PERMITTED_VIEWS.REPORTS_LOGIN_HISTORY,
        title: 'reports.loginHistory.title',
        type: 'sub',
        children: [
          {
            id: PERMITTED_VIEWS.REPORTS_LOGIN_HISTORY_BACKOFFICE,
            path: '/reports/login-histories/backoffice',
            title: 'tools.ipAddressRestriction.backOffice',
            type: 'link',
          },
          {
            id: PERMITTED_VIEWS.REPORTS_LOGIN_HISTORY_PLAYER,
            path: '/reports/login-histories/player',
            title: 'reports.loginHistory.players',
            type: 'link',
          },
        ],
      },
      {
        id: PERMITTED_VIEWS.REPORTS_DOWNLOAD_CENTER,
        path: '/reports/report-history',
        title: 'reports.history.title',
        type: 'link',
      },
      {
        id: PERMITTED_VIEWS.REPORTS_BONUS_PROMOTIONAL_CODE,
        path: '/reports/bonus',
        title: 'reports.bonus.title',
        type: 'link',
        children: [
          {
            id: PERMITTED_VIEWS.BTN_CANCEL_BONUS,
            title: 'reports.bonus.cancelBonus',
          },
          {
            id: PERMITTED_VIEWS.BTN_VIEW_BONUS,
            title: 'reports.bonus.viewBonus',
          },
        ],
      },
    ],
  },
  {
    id: PERMITTED_VIEWS.PROMOTIONAL_TOOLS,
    title: 'promotionalTools.titleSidebar',
    icon: 'bonus-kit',
    type: 'sub',
    badgeType: 'light-primary',
    children: [
      {
        id: PERMITTED_VIEWS.PROMOTIONAL_TOOLS_BONUS,
        path: '/promotional-tools/bonus',
        title: 'promotionalTools.bonus.title',
        type: 'link',
        children: [
          {
            id: PERMITTED_VIEWS.PROMOTIONAL_TOOLS_BONUS_ADD_BTN,
            title: 'promotionalTools.bonus.viewBonusAddBtn',
          },
          {
            id: PERMITTED_VIEWS.PROMOTIONAL_TOOLS_BONUS_EDIT_BTN,
            title: 'promotionalTools.bonus.edit',
          },
          {
            id: PERMITTED_VIEWS.PROMOTIONAL_TOOLS_BONUS_PAUSE_BTN,
            title: 'promotionalTools.bonus.viewBonusPauseBtn',
          },
          {
            id: PERMITTED_VIEWS.PROMOTIONAL_TOOLS_BONUS_CLONE_BTN,
            title: 'promotionalTools.bonus.viewBonusCloneBtn',
          },
        ],
      },
      {
        id: PERMITTED_VIEWS.PROMOTIONAL_TOOLS_CODES,
        path: '/promotional-tools/promotional-codes',
        title: 'promotionalTools.promotionalCodes.title',
        type: 'link',
        children: [
          {
            id: PERMITTED_VIEWS.PROMOTIONAL_TOOLS_CODES_ADD_BTN,
            title: 'promotionalTools.promotionalCodes.add',
          },
          {
            id: PERMITTED_VIEWS.PROMOTIONAL_TOOLS_CODES_SEND_IN_BULK_BTN,
            title: 'promotionalTools.promotionalCodes.sendInBulk',
          },
          {
            id: PERMITTED_VIEWS.PROMOTIONAL_TOOLS_CODES_EDIT_BTN,
            title: 'promotionalTools.promotionalCodes.edit',
          },
        ],
      },
      {
        id: PERMITTED_VIEWS.PROMOTIONAL_TOOLS_BONUS_INFO,
        path: '/promotional-tools/bonus-information',
        title: 'pageManagement.pageConfiguration.options.bonusInformation',
        type: 'link',
      },
      {
        id: PERMITTED_VIEWS.ANNOUNCEMENTS_LIST,
        path: '/promotional-tools/announcements/announcements-list',
        title: 'announcements.titleSidebar',
        type: 'link',
        children: [
          {
            id: PERMITTED_VIEWS.ANNOUNCEMENTS_CREATE_BTN,
            title: 'announcements.createAnnouncement',
          },
          {
            id: PERMITTED_VIEWS.ANNOUNCEMENTS_EDIT_BTN,
            title: 'announcements.editAnnouncement',
          },
          {
            id: PERMITTED_VIEWS.ANNOUNCEMENTS_STATE_BTN,
            title: 'announcements.changeStateAnnouncement',
          },
          {
            id: PERMITTED_VIEWS.ANNOUNCEMENTS_VIEW_INFORMATION_ADVANCED,
            title: 'announcements.viewInformationAdvanced',
          },
        ],
      },
    ],
  },
  {
    id: PERMITTED_VIEWS.FINANCIAL,
    title: 'financial.titleSidebar',
    icon: 'ecommerce',
    type: 'sub',
    badgeType: 'light-primary',
    children: [
      {
        id: PERMITTED_VIEWS.FINANCIAL_BANK_ENTITIES,
        path: '/financial/bank-entities',
        title: 'financial.bankEntities.title',
        type: 'link',
      },
      {
        id: PERMITTED_VIEWS.FINANCIAL_HOLDERS,
        path: '/financial/holders',
        title: 'financial.holders.title',
        type: 'link',
      },
      {
        id: PERMITTED_VIEWS.FINANCIAL_TRANSACTIONS,
        path: '/financial/transactions',
        title: 'financial.transactions.title',
        type: 'link',
      },
      {
        id: PERMITTED_VIEWS.FINANCIAL_WITHDRAWAL_REQUEST,
        path: '/financial/withdrawal-request',
        title: 'financial.withdrawalRequest.title',
        type: 'link',
      },
      {
        id: PERMITTED_VIEWS.FINANCIAL_DEPOSIT_REQUEST,
        path: '/financial/deposit-request',
        title: 'financial.depositRequest.title',
        type: 'link',
      },
    ],
  },
  {
    id: PERMITTED_VIEWS.TOOLS,
    title: 'tools.titleSidebar',
    icon: 'icons',
    type: 'sub',
    badgeType: 'light-primary',
    children: [
      {
        id: PERMITTED_VIEWS.TOOLS_COMMISSION_PLANS,
        path: '/tools/commission-plans',
        title: 'tools.commissionPlans.title',
        type: 'link',
      },
      {
        id: PERMITTED_VIEWS.TOOLS_RESTRICTIONS_IP_ADDRESS,
        path: '/tools/restrictions-ip-address',
        title: 'tools.ipAddressRestriction.title',
        type: 'link',
      },
      {
        id: PERMITTED_VIEWS.TOOLS_REFERAL_COMMISSION,
        path: '/tools/referal-commission',
        title: 'tools.referalCommission.title',
        type: 'link',
      },
    ],
  },
  {
    id: PERMITTED_VIEWS.USER_MANAGEMENT,
    title: 'userManagement.titleSidebar',
    icon: 'builders',
    type: 'sub',
    badgeType: 'light-primary',
    children: [
      {
        id: PERMITTED_VIEWS.USER_MANAGEMENT_USERS,
        path: '/user-management/users',
        title: 'userManagement.users.title',
        type: 'link',
        children: [
          {
            id: PERMITTED_VIEWS.USER_ACCOUNT_VIEW,
            title: 'profile.showProfile',
          },
          {
            id: PERMITTED_VIEWS.BTN_ADD_USER_NAV,
            title: 'profile.utilsNav.btnAddUserViewNav',
            children: [
              {
                id: PERMITTED_VIEWS.BTN_ADD_AGENT,
                title: 'profile.utilsNav.addAgentView',
              },
              {
                id: PERMITTED_VIEWS.BTN_ADD_PLAYER,
                title: 'profile.utilsNav.addPlayerView',
              },
              {
                id: PERMITTED_VIEWS.BTN_ADD_COLLABORATOR,
                title: 'profile.utilsNav.addCollaboratorView',
              },
              {
                id: PERMITTED_VIEWS.BTN_ADD_COLLABORATOR_AGENT,
                title: 'profile.utilsNav.addCollaboratorAgentView',
              },
            ],
          },
          {
            id: PERMITTED_VIEWS.BTN_TRANSFER_NAV,
            title: 'profile.utilsNav.btnTransferViewNav',
            children: [
              {
                id: PERMITTED_VIEWS.BTN_TRANSFER_AGENT,
                title: 'profile.utilsNav.transferAgentView',
              },
              {
                id: PERMITTED_VIEWS.BTN_TRANSFER_PLAYER,
                title: 'profile.utilsNav.transferPlayerView',
              },
              {
                id: PERMITTED_VIEWS.BTN_TRANSFER_CREDIT_AGENT,
                title: 'profile.utilsNav.transferCreditAgentView',
              },
              {
                id: PERMITTED_VIEWS.BTN_TRANSFER_COLLABORATOR,
                title: 'profile.utilsNav.transferCollaboratorView',
              },
            ],
          },
          {
            id: PERMITTED_VIEWS.VIEW_BALANCE_NAV,
            title: 'profile.utilsNav.viewBalanceViewNav',
          },
          {
            id: PERMITTED_VIEWS.VIEW_CREDITS_NAV,
            title: 'profile.utilsNav.viewCreditsViewNav',
          },
          {
            id: PERMITTED_VIEWS.USER_MANAGEMENT_USERS_ADD_BTN,
            title: 'userManagement.users.add',
          },
          {
            id: PERMITTED_VIEWS.USER_MANAGEMENT_USERS_EDIT_BTN,
            title: 'userManagement.users.edit',
          },
          {
            id: PERMITTED_VIEWS.USER_MANAGEMENT_USERS_UPDATE_PASSWORD_BTN,
            title: 'userManagement.users.viewUpadatePasswordBtn',
          },
        ],
      },
      {
        id: PERMITTED_VIEWS.USER_MANAGEMENT_AGENTS,
        path: '/user-management/agents',
        title: 'agents.titleSidebar',
        type: 'link',
        children: [
          {
            id: PERMITTED_VIEWS.USER_MANAGEMENT_AGENT_ADD_BTN,
            title: 'userManagement.users.viewAddAgentBtn',
          },
          {
            id: PERMITTED_VIEWS.USER_MANAGEMENT_AGENT_EDIT_BTN,
            title: 'userManagement.users.viewEditAgentBtn',
          },
          {
            id: PERMITTED_VIEWS.USER_MANAGEMENT_AGENT_UPDATE_PASSWORD_BTN,
            title: 'userManagement.users.viewUpadatePasswordBtn',
          },
          {
            id: PERMITTED_VIEWS.USER_MANAGEMENT_AGENT_BET_LIMIT_BTN,
            title: 'players.player.betLimits.title',
          },
        ],
      },

      {
        id: PERMITTED_VIEWS.USER_MANAGEMENT_COLLABORATOR_AGENTS,
        path: '/user-management/collaborator-agents',
        title: 'userManagement.collaboratorAg.title',
        type: 'link',
        children: [
          {
            id: PERMITTED_VIEWS.USER_MANAGEMENT_COLLABORATOR_AGENTS_ADD_BTN,
            title: 'userManagement.collaboratorAg.add',
          },
          {
            id: PERMITTED_VIEWS.USER_MANAGEMENT_COLLABORATOR_AGENTS_EDIT_BTN,
            title: 'userManagement.collaboratorAg.edit',
          },
          {
            id: PERMITTED_VIEWS.USER_MANAGEMENT_COLLABORATOR_AGENTS_UPDATEPASSWORD_BTN,
            title: 'userManagement.users.viewUpadatePasswordBtn',
          },
        ],
      },
      {
        id: PERMITTED_VIEWS.USER_MANAGEMENT_ROLES_PERMISSION,
        path: '/user-management/roles-permission',
        title: 'userManagement.role.title',
        type: 'link',
      },
    ],
  },
  {
    id: PERMITTED_VIEWS.SPORT_MANAGEMENT,
    title: 'sportManagement.titleSidebar',
    icon: 'internationalization',
    type: 'sub',
    badgeType: 'light-primary',
    children: [
      {
        id: PERMITTED_VIEWS.SPORT_MANAGEMENT_BET_LIMIT,
        path: '/sport-management/bet-limit',
        title: 'sportManagement.betLimit.title',
        type: 'sub',
        children: [
          {
            id: PERMITTED_VIEWS.SPORT_MANAGEMENT_BET_LIMIT_GLOBAL,
            path: '/sport-management/bet-limit/global',
            title: 'sportManagement.betLimit.globalLimits.title',
            type: 'link',
            children: [
              {
                id: PERMITTED_VIEWS.BET_LIMIT_GLOBAL_VIEW,
                title: 'btn.view',
              },
              {
                id: PERMITTED_VIEWS.BET_LIMIT_GLOBAL_EDIT,
                title: 'btn.edit',
              },
              {
                id: PERMITTED_VIEWS.BET_LIMIT_GLOBAL_ADD,
                title: 'btn.add',
              },
            ],
          },
        ],
      },
      {
        id: PERMITTED_VIEWS.SPORT_MANAGEMENT_EVENT_MANAGER,
        path: '/sport-management/event-manager',
        title: 'sportManagement.eventManager.title',
        type: 'sub',
        children: [
          {
            id: PERMITTED_VIEWS.SPORT_MANAGEMENT_EVENT_MANAGER_PREMATCH,
            path: '/sport-management/event-manager/pre-match',
            title: 'sportManagement.eventManager.prematch.title',
            type: 'link',
          },
          {
            id: PERMITTED_VIEWS.SPORT_MANAGEMENT_EVENT_MANAGER_LIVE,
            path: '/sport-management/event-manager/live',
            title: 'sportManagement.eventManager.live.title',
            type: 'link',
          },
        ],
      },
    ],
  },
  {
    id: PERMITTED_VIEWS.CASINO_MANAGEMENT,
    title: 'casinoManagement.titleSidebar',
    icon: 'icons',
    type: 'sub',
    badgeType: 'light-primary',
    children: [
      {
        id: PERMITTED_VIEWS.CASINO_MANAGEMENT_OPERATOR,
        path: '/casino-management/operator-management',
        title: 'casinoManagement.operatorManagement.title',
        type: 'link',
      },
      {
        id: PERMITTED_VIEWS.CASINO_MANAGEMENT_PROVIDER,
        path: '/casino-management/provider-management',
        title: 'casinoManagement.providerManagement.title',
        type: 'link',
      },
      {
        id: PERMITTED_VIEWS.CASINO_MANAGEMENT_GAMES,
        path: '/casino-management/games-management',
        title: 'casinoManagement.gamesManagement.title',
        type: 'link',
      },
    ],
  },
  {
    id: PERMITTED_VIEWS.PAGE_MANAGEMENT,
    title: 'pageManagement.titleSidebar',
    icon: 'landing-page',
    type: 'sub',
    badgeType: 'light-primary',
    children: [
      {
        id: PERMITTED_VIEWS.PAGE_MANAGEMENT_TOURNAMENT,
        path: '/page-management/tournament-management',
        title: 'pageManagement.tournamentManagement.title',
        type: 'link',
      },
      {
        id: PERMITTED_VIEWS.PAGE_MANAGEMENT_SECTION,
        path: '/page-management/section-management',
        title: 'pageManagement.sectionManagement.title',
        type: 'link',
      },
      {
        id: PERMITTED_VIEWS.PAGE_MANAGEMENT_PROMOTION,
        path: '/page-management/promotion-management',
        title: 'pageManagement.promotionManagement.title',
        type: 'link',
      },
      {
        id: PERMITTED_VIEWS.PAGE_CONFIGURATION,
        path: '/page-management/page-configuration',
        title: 'pageManagement.pageConfiguration.title',
        type: 'link',
      },
      {
        id: PERMITTED_VIEWS.PAGE_MANAGEMENT_FORMS,
        path: '/page-management/forms-configuration',
        title: 'pageManagement.formsConfig.title',
        type: 'link',
      },
    ],
  },
  {
    id: PERMITTED_VIEWS.REAL_TIME,
    title: 'realTime.titleSidebar',
    icon: 'table',
    type: 'sub',
    badgeType: 'light-primary',
    children: [
      {
        id: PERMITTED_VIEWS.REAL_TIME_JOURNEY,
        path: '/real-time/journey',
        title: 'realTime.journey.journey',
        type: 'link',
      },
    ],
  },
  /*  {
    id: PERMITTED_VIEWS.BETSHOP_MANAGEMENT,
    title: 'betshopManagement.title',
    icon: 'home',
    type: 'sub',
    badgeType: 'light-primary',
    children: [
      {
        id: PERMITTED_VIEWS.BETSHOP_MANAGEMENT_BETSHOP,
        path: '/betshop-management/betshop',
        title: 'betshopManagement.betshops.title',
        type: 'link',
      },
      {
        id: PERMITTED_VIEWS.BETSHOP_MANAGEMENT_CASHDESK,
        path: '/betshop-management/cashdesk',
        title: 'betshopManagement.cashdesks.title',
        type: 'link',
      },
    ],
  }, */
  {
    id: PERMITTED_VIEWS.AFFILIATES,
    title: 'affiliates.titleSidebar',
    icon: 'social',
    type: 'sub',
    badgeType: 'light-primary',
    children: [
      {
        id: PERMITTED_VIEWS.AFFILIATES_REFERRAL_LINK,
        path: '/affiliates/referrals-link',
        title: 'affiliates.referralsLink',
        type: 'link',
      },
      {
        id: PERMITTED_VIEWS.AFFILIATES_ANALYTICS,
        path: '/affiliates/affiliate-analytics',
        title: 'affiliates.analytics',
        type: 'link',
      },
    ],
  },
  {
    id: PERMITTED_VIEWS.DIRECT_LOADS,
    title: 'directLoads.title',
    icon: 'bonus-kit',
    type: 'sub',
    badgeType: 'light-primary',
    children: [
      {
        id: PERMITTED_VIEWS.DIRECT_LOADS_ADMINISTRATIVE,
        path: '/direct-loads/administrative',
        title: 'directLoads.administrative.title',
        type: 'link',
      },
    ],
  },
  {
    id: PERMITTED_VIEWS.SUPPORT,
    title: 'support.title',
    icon: 'bonus-kit',
    type: 'sub',
    badgeType: 'light-primary',
    children: [
      {
        id: PERMITTED_VIEWS.RESOLVE_PENDING_BETS,
        path: '/support/resolve-pending-bets',
        title: 'directLoads.administrative.resolvePendingBets',
        type: 'link',
        children: [
          {
            id: PERMITTED_VIEWS.RESOLVE_PENDING_BETS_BY_DATE_RANGE,
            title: 'directLoads.resolveBet.byDateRange',
          },
          {
            id: PERMITTED_VIEWS.RESOLVE_PENDING_BETS_BY_BET_ID,
            title: 'directLoads.resolveBet.byBetLocalId',
          },
          {
            id: PERMITTED_VIEWS.REQUEST_SETTLEMENTS_BY_EVENT_ID,
            title: 'directLoads.resolveBet.requestSettlementsByEventId',
          },
        ],
      },
    ],
  },
];
